import React from 'react';
import { noop } from 'lodash';
import { AdditionalValue } from './AdditionalValue';

/**
 * @note
 * Sets fake anchor tag's href attribute to "#" without triggering eslint warnings.
 * Previously these anchor tags used unsave `javascript:;/javascript:void(0);` href values,
 * which is a form of unsafe-eval.
 */
const falsePath = '#';

export const AdditionalBalances = ({
  account,
  balances,
  onFAQAnchorClick = noop,
  content = {},
}) => {
  let additionalBalances = [];

  /** todo diagnose issues with invlaid element types */
  additionalBalances = account.balances.map(({ type }, index) => {
    switch (type) {
      case 'cleared':
        return (
          <AdditionalValue
            key={`AdditionalBalances_cleared_${index}`}
            balance={balances.clearedBalance}
            displayText={content.clearedBalance}
          >
            <p className="type--bute">
              {content.clearedBalanceExplanationText}
            </p>
          </AdditionalValue>
        );

      case 'isa_taxyear_to_date_deposits':
        return (
          <AdditionalValue
            key={`AdditionalBalances_isa_taxyear_to_date_deposits_${index}`}
            balance={balances.isaTaxYearDateDeposits}
            displayText={content.isaTaxYearDisplayText}
          >
            <p className="type--bute">
              {content.isaTaxYearDepositExplanationText}
              <a
                href={falsePath}
                role="button"
                onClick={(e) => {
                  e.preventDefault();
                  onFAQAnchorClick(e);
                }}
              >
                <u>FAQ's.</u>
              </a>
            </p>
          </AdditionalValue>
        );
      case 'isa_total_deposits_allowance_remaining':
        return (
          <AdditionalValue
            key={`AdditionalBalances_isa_total_deposits_allowance_remaining_${index}`}
            balance={balances.isaTotalDepositAllowance}
            displayText={content.isaTotalDepositDisplayText}
          >
            <p className="type--bute">
              {content.isaTotalDepositExplanationText}
              <a
                href={falsePath}
                role="button"
                onClick={(e) => {
                  e.preventDefault();
                  onFAQAnchorClick(e);
                }}
              >
                <u>FAQ's.</u>
              </a>
            </p>
          </AdditionalValue>
        );
      default: {
        return null;
      }
    }
  });

  /**
   * In React 15, rendering an array with `null` elements can lead to issues.
   * Filter out `null` before returning.
   */
  return (
    <span>{additionalBalances.filter((element) => element !== null)}</span>
  );
};
